import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ConversationsAnalyticsPageStore } from 'pages/analytics/pages/conversations/store/conversationsAnalyticsPageStore'

const ConversationsAnalyticsPageContext = createContext<ConversationsAnalyticsPageStore | null>(
  null
)

export const useConversationsAnalyticsPageContext = () => {
  const context = useContext(ConversationsAnalyticsPageContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with ConversationsAnalyticsPageProvider'
    )

  return context
}

export const ConversationsAnalyticsPageProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new ConversationsAnalyticsPageStore(entities), [])

  useEffect(() => {
    void store.init()

    return () => {
      store.dispose()
    }
  }, [])

  return (
    <ConversationsAnalyticsPageContext.Provider value={store}>
      {children}
    </ConversationsAnalyticsPageContext.Provider>
  )
}
